
export const swiperHome = () => {
    new Swiper(".swiper-home", {
                
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        effect: "fade",
    });   
};


export const swiperEmprendimientosDestacados = () => {
    new Swiper(".swiper-emprendimientos-destacados", {
                
        slidesPerView: 1.15,
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true
        },
        loop: true,
        autoplay: false,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 2.5,
                spaceBetween: 20,
            }
        }
    });   
};

export const swiperLeedResumen = () => {
    new Swiper(".swiper-leed-resumen", {
                
        slidesPerView: 1,
        spaceBetween: 20,
        effect: "fade",
        loop: true,
        autoplay: true,

    });   
};

export const swiperUbicacionManantiales = () => {
    new Swiper(".swiper-ubicacion", {
                
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true
        },

    });   
};

// Inicializa primero el swiper de miniaturas
export const swiperManantialesBtn = new Swiper(".swiper-manantiales-btn", {
    slidesPerView: 4,
    spaceBetween: 0,
    loop: false,
    autoplay: false,
    watchSlidesProgress: true,
});

// Luego, inicializa el swiper principal y referencia el swiper de miniaturas
export const swiperManantiales = new Swiper(".swiper-manantiales", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: false,
    loop: true,
    effect: "fade",
    thumbs: {
        swiper: swiperManantialesBtn,
    },
});

export const swiperManantialesFicheros = new Swiper(".swiper-manantiales-ficheros", {
    autoplay: false,
    loop: true,
    direction: 'vertical',
    effect: "cards",
    thumbs: {
        swiper: swiperManantialesBtn,
    },
});

export const swiperOportunidades = () => {
    new Swiper(".swiper-oportunidades", {
                
        slidesPerView: 1.15,
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-oportunidades .swiper-button-next",
            prevEl: ".swiper-oportunidades .swiper-button-prev",
        },
        pagination: {
            el: ".swiper-oportunidades .swiper-pagination",
            clickable: true,
            dynamicBullets: true
        },
        loop: true,
        autoplay: false,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3.50,
                spaceBetween: 20,
            },
            1600: {
                slidesPerView: 4,
                spaceBetween: 20,
            }
        }
    });   
};

export const swiperEmprendimientos = () => {
    new Swiper(".swiper-emprendimientos", {
                
        slidesPerView: 2,
        spaceBetween: 4,
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: true,
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 6,
            }
        }
    });   
};

export const swiperAvances = () => {
    new Swiper(".swiper-avances", {
                
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-avances .swiper-button-next",
            prevEl: ".swiper-avances .swiper-button-prev",
        },
        pagination: {
            el: ".swiper-avances .swiper-pagination",
            clickable: true,
            dynamicBullets: true
        },
        loop: true,
        autoplay: false,
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
                loop: false
            }
        }
    });   
};

export const swiperAmenities = () => {
    new Swiper(".swiper-amenities", {
                
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-amenities .swiper-button-next",
            prevEl: ".swiper-amenities .swiper-button-prev",
        },
        pagination: {
            el: ".swiper-amenities .swiper-pagination",
            clickable: true,
            dynamicBullets: true
        },
        loop: true,
        autoplay: true,
    });   
};


export const swiperManantialesDestacados = () => {
    new Swiper(".swiper-manantiales-destacados", {
                
        slidesPerView: 0.65,
        spaceBetween: 20,
        pagination: {
            el: ".swiper-manantiales-destacados .swiper-pagination",
            clickable: true,
            dynamicBullets: true
        },
        loop: true,
        //autoplay: true,
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 1.15,
                spaceBetween: 20,
            }
        }
    });   
};

export const swiperManantialesUbicacion = () => {
    new Swiper(".swiper-manantiales-ubicacion", {
                
        slidesPerView:1,
        spaceBetween: 20,
        pagination: {
            el: ".swiper-manantiales-ubicacion .swiper-pagination",
            clickable: true,
            dynamicBullets: true
        },
        loop: true,
        autoplay: true,
    });   
};

export const swiperInfraestructura = () => {
    new Swiper(".swiper-infraestructura", {
                
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-infraestructura .swiper-button-next",
            prevEl: ".swiper-infraestructura .swiper-button-prev",
        },
        pagination: {
            el: ".swiper-infraestructura .swiper-pagination",
            clickable: true,
            dynamicBullets: true
        },
        loop: true,
        autoplay: true,
    });   
};

export const swiperQuienesSomos = () => {
    new Swiper(".swiper-quienes-somos", {
                
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        effect: "fade",
    });   
};

export const swiperSustentabilidad = () => {
    new Swiper(".swiper-sustentabilidad", {
                
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        effect: "fade",
    });   
};

export const swiperNuestrosValores = () => {
    new Swiper('.swiper-valores', {
        slidesPerView: 1.20,
        spaceBetween: 16,
        loop: true,
        loopAddBlankSlides: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                spaceBetween: 24,
                pagination: false,
                navigation: false,
                loop:false,
                slidesPerView: 2,
                grid: {
                    rows: 3
                  },
            }
        }
    });
};

export const swiperCaracteristicasCertificacion = () => {
    new Swiper('.swiper-caracteristicas-certificacion', {
        slidesPerView: 1.1,
        spaceBetween: 16,
        loop: true,
        autoplay: true,
        loopAddBlankSlides: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                pagination: false,
                navigation: false,
                spaceBetween: 24,
                loop:false,
                autoplay:false,
                loopAddBlankSlides: false,
                fill: 'columm',
                slidesPerView: 3,
                grid: {
                    rows: 2
                  },
            }
        }
    });
};

export const swiperSociosAvatares = new Swiper(".swiper-socios-avatares", {
    slidesPerView: 3,
    spaceBetween: 16,
    loop: false,
    autoplay: false,
    watchSlidesProgress: true,
});

export const swiperSocios = new Swiper(".swiper-socios", {
    slidesPerView: 1,
    spaceBetween: 16,
    autoplay: false,
    loop: true,
    autoHeight: true,
    effect: "fade",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    },
    thumbs: {
        swiper: swiperSociosAvatares,
    },
});

export const swiperNuestrasVentajas = () => {
    new Swiper('.swiper-ventajas', {
        slidesPerView: 1,
        spaceBetween: 16,
        autoplay: true,
        loop: true,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
};

export const swiperGrupoEdisur = () => {
    new Swiper('.swiper-grupo-edisur', {
        slidesPerView: 1,
        spaceBetween: 16,
        autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                autoplay: false,
                loop: false,
                slidesPerView: 3
            }
        }
    });
};

export const swiperNormas = () => {
    new Swiper('.swiper-normas-certificaciones', {
        slidesPerView: 1.25,
        spaceBetween: 0,
        autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 5
            }
        }
    });
};

export const swiperLeedCities = new Swiper(".swiper-leed-cities", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: false,
    loop: true,
    effect: "fade",
});

export const swiperLeedCitiesCaption = new Swiper(".swiper-leed-cities-caption", {
    autoplay: false,
    loop: true,
    slidesPerView: 1,
    autoplay: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
});